// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"b87986e5","743":"733d081a","917":"eee0f84e"}[chunkId] + ".chunk.js";
};